import Page from "../../layouts/Page";
import messages from '@super-template/messages';
import {FormattedMessage, useIntl} from 'react-intl';
import {
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from "@material-ui/core";
import BackButton from "@super-template/core/src/BackButton";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import {useTheme} from "@material-ui/core/styles";

export const path = '/:organization/cookies';
export const exact = true;

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    '& p, h2': {
      marginBottom: theme.spacing(2)
    },
    '& table, .mobileContent': {
      marginBottom: theme.spacing(4)
    }
  },
  table: {
    '& th': {
      fontFamily: theme.typography.bold
    }
  }
}));

export const component = function Cookies() {
  const classes = useStyles();
  const intl = useIntl();
  const isMobile = useMediaQuery(useTheme().breakpoints.down('xs'), {noSsr: true});

  return (
    <Page title={<FormattedMessage {...messages.cookie_title} />}>
      <Paper className={classes.root}>
        <Typography variant="h5" component="h2" className={classes.title}>
          <FormattedMessage {...messages.cookie_title} />
        </Typography>
        <Typography variant={"body1"}><FormattedMessage {...messages.cookie_info} /></Typography>
        <Typography variant={"body1"}>
          <FormattedMessage {...messages.cookie_read_more} />{' '}
          <a
            href={"https://www.kyberturvallisuuskeskus.fi/fi/toimintamme/saantely-ja-valvonta/luottamuksellinen-viestinta"}
            rel="noreferrer"
            target={"_blank"}><FormattedMessage {...messages.cookie_read_more_from} /></a>
        </Typography>
        <Typography variant={"body1"}><FormattedMessage {...messages.cookie_law} /></Typography>
        <Typography variant={"body1"}><FormattedMessage {...messages.cookies} /></Typography>
        {isMobile ?
          <div className={"mobileContent"}>
            <Typography variant="h6" component="label">JSESSIONID</Typography>
            <Typography variant={"body1"}><FormattedMessage {...messages.cookie_session_id} /></Typography>
            <Typography variant="h6" component="label">OAuth_Token_Request_State</Typography>
            <Typography variant={"body1"}><FormattedMessage {...messages.cookie_oauth} /></Typography>
          </div> :
          <TableContainer className={classes.table}>
            <Table size="small" id={"cookieTable"} aria-label={intl.formatMessage(messages.cookie_table)}>
              <TableHead>
                <TableRow>
                  <TableCell><FormattedMessage {...messages.name} /></TableCell>
                  <TableCell><FormattedMessage {...messages.meaning} /></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>JSESSIONID</TableCell>
                  <TableCell><FormattedMessage {...messages.cookie_session_id} /></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>OAuth_Token_Request_State</TableCell>
                  <TableCell><FormattedMessage {...messages.cookie_oauth} /></TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>}
        <BackButton variant="contained" color="primary"/>
      </Paper>
    </Page>
  );
};
